import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { toast } from 'react-toastify';
import { Alert, Badge, Modal, ModalBody, ModalHeader } from 'reactstrap';

import style from '../../styles/layout.module.css';
import request from '../../utils/useAxios';


const SortBannerModel = ({ openModal = false, setOpenModel = () => {} }) => {
  const [banners, setBanners] = useState([]);
  const sortBanners = useRef([]);

  const getAllBannerList = useCallback(async () => {
    const res = await request({
      data: {
        order: '',
        order_by: '',
        page: 0,
        page_size: 0,
        type: 0,
      },
      method: 'post',
      url: '/Backend/Cafe_HomeBanner/topHome/list',
    });
    if (res.code === 200) {
      return (res.result.datas || []).map((data, index) => {
        return {
          index: index + 1,
          ...data,
        };
      });
    } else {
      return [];
    }
  }, []);

  const sortBannerList = useCallback(async banners => {
    const res = await request({
      data: banners.map((banner, index) => {
        return {
          id: banner.id,
          sort: index,
        };
      }),
      method: 'post',
      url: '/Backend/Cafe_HomeBanner/topHome/sort',
    });
    if (res.code === 200) {
      toast.success('修改完成');
      return res;
    } else {
      toast.success('修改失敗');
      throw res;
    }
  }, []);

  const handleOnDragEnd = result => {
    const { source, destination, draggableId } = result;
    if (!destination) {
      return;
    }
    const [remove] = sortBanners.current.splice(source.index, 1);
    sortBanners.current.splice(destination.index, 0, remove);
    setBanners(sortBanners.current);
  };

  useEffect(() => {
    if (openModal) {
      getAllBannerList().then(banners => {
        setBanners(banners);
        sortBanners.current = [...banners];
      });
    }
  }, [openModal, getAllBannerList, setBanners]);

  return (
    <div className={style.modal}>
      <Modal
        centered
        size="lg"
        isOpen={openModal}
        toggle={() => {
          sortBannerList(banners).then(() => {
            setOpenModel(false);
          });
        }}
        backdrop="static"
      >
        <ModalHeader
          className={style.modal_head}
          toggle={() => {
            sortBannerList(banners).then(() => {
              setOpenModel(false);
            });
          }}
        >
          形象圖片排序
        </ModalHeader>
        <ModalBody>
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="brands">
              {provided => (
                <ul
                  className="drag_list"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {banners.map((banner, index) => (
                    <Draggable
                      key={banner.id}
                      draggableId={`${banner.id}`}
                      index={index}
                    >
                      {provided => (
                        <li
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}
                        >
                          <Alert color="warning" className="d-flex p-0 w-100">
                            <Badge className="d-flex align-items-center">
                              {banner.index}
                            </Badge>
                            <img
                              className="mx-5"
                              alt="Card"
                              height="50"
                              src={banner.bannerUrl}
                            />
                          </Alert>
                        </li>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </ul>
              )}
            </Droppable>
          </DragDropContext>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default memo(SortBannerModel);
